module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNzkuNDMyIiBoZWlnaHQ9IjU4MC4zMjYiIHZpZXdCb3g9IjAgMCAxNzkuNDMyIDU4MC4zMjYiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzU5NiIgZGF0YS1uYW1lPSLjg5HjgrkgMzU5NiIgZD0iTTg1NS4wMjYtODcuNWwxNzkuNDMyLTY4LjAwN1YzNTYuODA5TDg1NS4wMjYsNDI0LjgxNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NTUuMDI2IDE1NS41MSkiIGZpbGw9ImJsdWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/blue_179.svg
// module id = igti
// module chunks = 0